export default __webpack_public_path__ + "static/media/presentation.db1b3c78.jpg";